export const routes = {
  devLogin: () => "/login",

  homePage: () => "/app/dashboard/",

  connect: {
    reports: () => "/app/connect/reports/",
    manualCaseCreation: () => nextUrl("/app/manual-case-creation"),
    payslipList: () => "/app/payslip/list/",
  },

  survey: {
    home: () => "/app/survey/home/",
    templates: () => "/app/survey/templates/",
    questionTypes: () => "/app/survey/questiontypes/",
    questionBank: () => "/app/survey/questionbank/",
    reportingCategories: () => "/app/survey/reporting/categories/",
    surveyBank: () => nextUrl("/engage/survey-bank"),
    manageAssociation: () =>
      nextUrl("/engage/survey-bank/manage-association"),
  },

  eLearning: {
    reports: () => "/app/elearning/reports/",
  },

  companyPost: {
    reports: () => "/app/companypost/reports/",
  },

  myWovo: {
    workerContacts: () => "/app/worker_contacts/list/",
    accountInfo: () => nextUrl("/app/mywovo/account-info"),
  },

  adminSettings: {
    localisation: () => "/app/admin/settings/localisation/",
    manageTranslations: () =>
      nextUrl("/app/admin/settings/manage-translations"),
  },

  administration: {
    roles: () => nextUrl("/administration/roles"),
    users: () => nextUrl("/administration/users"),
    adminUsers: () => nextUrl("/administration/admin-users"),
    lessonAssociation: () => nextUrl("/administration/lesson-association"),
  },
  downloads: () => nextUrl("/downloads"),
  user: {
    settings: () => nextUrl("/user/settings"),
  },
  authentication: {
    logout: () => nextUrl("/logout"),
  },
  maintenancePage: () => nextUrl("/maintenance"),

  engage: (queryParams = "") => {
    if (!queryParams) return nextUrl("/engage");
    const prefix = queryParams.startsWith("?") ? "" : "?";
    return nextUrl(`/engage${prefix}${queryParams}`);
  },
};

export function nextUrl(path) {
  return `${process.env.REACT_APP_NEXT_APP_URL}/next${path}`;
}
